/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export type HttpMethod
  = 'GET'
  | 'POST'
  | 'PUT'
  | 'DELETE'
  | 'HEAD'
  | 'CONNECT'
  | 'OPTIONS'
  | 'TRACE'
  | 'PATCH';

export class HttpMethods {
  static readonly GET = 'GET';
  static readonly POST = 'POST';
  static readonly PUT = 'PUT';
  static readonly DELETE = 'DELETE';
  static readonly HEAD = 'HEAD';
  static readonly CONNECT = 'CONNECT';
  static readonly OPTIONS = 'OPTIONS';
  static readonly TRACE = 'TRACE';
  static readonly PATCH = 'PATCH';
}
